window.onload = () => {
    (function(window, document, undefined) {
        "use strict";

        /**********************************\
         - KEEPING TRACK OF INPUT METHODS
        \**********************************/
        var tabActive = false;

        //KEY EVENTS
        function keyDownHandler(e) {
            tabActive = e.keyCode === 9 || e.which === 9;
        }

        function keyUpHandler(e) {
            tabActive = false;
        }

        document.documentElement.addEventListener('keydown', keyDownHandler, true);
        document.documentElement.addEventListener('keyup', keyUpHandler, true);


        /***************************************\
         - UPDATING ATTRIBUTES ON FOCUS & BLUR
        \***************************************/
        var focusableElems = Array.prototype.slice.call(
            document.querySelectorAll("a, input, textarea, select, button, [tabindex]")
        );

        focusableElems.forEach(function(elem) {
            elem.addEventListener("focus",
                function(e) {
                    document.documentElement.dataset.focusSource = this.dataset.focusSource = tabActive ? "tab" : "";
                });

            elem.addEventListener("blur",
                function(e) {
                    document.documentElement.dataset.focusSource = this.dataset.focusSource = "";
                });
        });

    })(this, document)
};